import { createSelector } from 'react-sweet-state';

import type { FieldId } from '../../../../common/types/form/form-fields';
import type { FormRendererState } from '../../types';

export interface FormFieldSelectorProps {
	fieldId: FieldId;
}
export const formFieldSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	FormFieldSelectorProps,
	import('../../../..').FormField
> = createSelector(
	(state: FormRendererState) => state.formFields,
	(_, props: FormFieldSelectorProps) => props.fieldId,
	(formFields, fieldId) => formFields[fieldId],
);
